import React from 'react';

import { GuideAccordionList } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { GpaGuideStrategyByGoal } from '@backrs_ui/grow-ui/src/pages/GpaGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type StrategyByGoalSectionProps = Readonly<{
  content: GpaGuideStrategyByGoal;
}>;

export const StrategyByGoalSection: React.FC<StrategyByGoalSectionProps> = ({ content }) => (
  <Box sx={containerSx}>
    <GuideAccordionList
      idPrefix="gpa-strategy"
      items={content.strategies.map((strategy) => ({
        id: strategy.id,
        title: strategy.title,
        details: (
          <Box component="ul" sx={listSx}>
            {strategy.points.map((point) => (
              <Typography key={point} component="li" variant="text-md-regular" sx={bodyTextSx}>
                {point}
              </Typography>
            ))}
          </Box>
        ),
      }))}
    />
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  pb: backrs.spacing['spacing-4xl'],
});

const listSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
  pl: backrs.spacing['spacing-xl'],
  m: 0,
});

const bodyTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
